import { Factory, trait, association } from 'miragejs';
import faker from 'faker';

import { ARTICLE_TYPES, ARTICLE_LAYOUTS } from '@api/articles/constants';

import { randomHtmlText } from './utils';

export default {
  // TODO: refactor as common versioned Factory
  article: Factory.extend({
    type: () => faker.random.arrayElement(ARTICLE_TYPES),
    title: (i) => `${i} ${faker.lorem.sentence()}`,
    layout: () => faker.random.arrayElement(ARTICLE_LAYOUTS),

    // TODO: refactor as common
    currentVersionId: () => faker.random.uuid(),
    publishedVersionId: () => faker.random.uuid(),

    standFirst: () => faker.lorem.sentences(),
    body: () => randomHtmlText(),

    featuredImage: (i) => `https://picsum.photos/600/400?random=${i}`,

    // TODO: refactor as common
    seoDescription: () => faker.lorem.sentences(),
    slug: () => faker.lorem.slug(),

    // TODO: refactor as common
    modified: () => faker.date.past().toISOString(),
    modifiedBy: association(),
    created: () => faker.date.past().toISOString(),
    createdBy: association(),

    // TODO: refactor as common versioned Factory
    published: trait({
      published: () => faker.date.past().toISOString(),
      publishedBy: association(),
    }),

    withEvent: trait({
      afterCreate(article, server) {
        if (!article.event) {
          article.update({
            event: server.create('event'),
          });
        }
      },
    }),

    withDisciplines: trait({
      afterCreate(article, server) {
        server.createList('discipline', 3, { article });
      },
    }),
    withAthletes: trait({
      afterCreate(article, server) {
        server.createList('athlete', 3, { article });
      },
    }),
    withDocuments: trait({
      afterCreate(article, server) {
        server.createList('document', 3, { article });
      },
    }),
    withCompetitions: trait({
      afterCreate(article, server) {
        server.createList('competition', 3, { article });
      },
    }),
    withUrls: trait({
      urls: () => [{ url: faker.internet.url(), title: faker.lorem.sentence() }],
    }),
    withArticles: trait({
      afterCreate(article, server) {
        server.createList('article', 3, { article });
      },
    }),
  }),
};
